import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';

const operatorOptions = [
  { label: 'After', value: 'after' },
  { label: 'Before', value: 'before' }
];

const unitsOptions = [
  { label: 'Days', value: 'day' },
  { label: 'Weeks', value: 'week' },
  { label: 'Months', value: 'month' }
];

export default function RelativeInputs({ value, onChange }) {
  if (!value.relativeDateId) {
    return null;
  }

  return (
    <div className="d-flex gap-2">
      <ManagedInput
        aria-label="modifier"
        className="form-control flex-fill"
        name="modifier"
        type="number"
        value={value.modifier}
        onValueChange={modifier => onChange({ modifier: modifier < 0 ? 0 : modifier })}
      />

      <ManagedInput
        aria-label="units"
        className="w-auto"
        name="units"
        type="select"
        value={value.units}
        onChange={onChange}
      >
        {unitsOptions.map(unit => (
          <option key={unit.value} value={unit.value}>
            {unit.label}
          </option>
        ))}
      </ManagedInput>

      <ManagedInput
        aria-label="operator"
        className="w-auto"
        name="operator"
        type="select"
        value={value.operator}
        onChange={onChange}
      >
        {operatorOptions.map(operator => (
          <option key={operator.value} value={operator.value}>
            {operator.label}
          </option>
        ))}
      </ManagedInput>
    </div>
  );
}

RelativeInputs.propTypes = {
  value: PropTypes.shape({
    modifier: PropTypes.number,
    operator: PropTypes.string,
    relativeDateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    units: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};
